import { StyledIconBase } from "@styled-icons/styled-icon";
import { Button, Col, IconButtonInverted, Row } from "components/primitives";
import styled from "styled-components";

export const ScheduleItemInner = styled(Row)`
  flex-grow: 1;
`;
export const DndBox = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 20px;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${(props) => props.color};
    filter: brightness(85%);
    border-radius: 8px 0 0 8px;
  }

  button {
    background-color: transparent;
    z-index: 10;

    &:disabled {
      background-color: transparent;

      svg {
        opacity: 0.5;
      }
    }
  }

  svg {
    width: 12px;

    path,
    rect {
      fill: white;
    }
  }
`;

export const OuterContainer = styled.div`
  margin-bottom: 35px;
`;

export const ScheduleContainer = styled(Col)`
  gap: 5px;
  max-height: 220px;
  overflow-y: auto;
`;

export const EmptySpace = styled.div`
  width: 15px;
`;

export const ScheduleItem = styled(Row)`
  height: 60px;
  width: 100%;
  gap: 5px;
`;

export const ScheduleItemButton = styled(Button)<{ color: string }>`
  width: 100%;
  background-color: ${(props) => props.color};
  border-radius: 0 8px 8px 0;
  padding: 5px;
  box-shadow: none;
  min-width: 0;
  color: white;

  ${Row} {
    align-items: center;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    margin-right: 15px;

    ${Col} {
      min-width: 0;
      justify-content: center;
      align-items: start;
      flex: 0.7;
      line-height: 1.3em;
      width: 100%;
      overflow: hidden;
      word-break: break-word;
      text-align: left;
    }
  }
`;

export const ScheduleItemDelete = styled(IconButtonInverted)`
  padding: 5px 8px;
  min-width: 25px;
  height: 100%;

  svg {
    max-width: 16px;

    path {
      fill: white;
    }
  }
`;

export const ScheduleItemAdd = styled(IconButtonInverted)`
  padding: 5px 8px;
  min-width: 25px;
  height: 100%;

  svg {
    max-width: 16px;

    path {
      fill: white;
    }
  }
`;

export const ScheduleItemImage = styled.div`
  flex: 0.15;
  font-size: 16pt;
`;

export const ScheduleItemLink = styled.div`
  width: 18px;
`;

export const FooterButton = styled(Button)`
  margin-top: 10px;
  width: 100%;
  height: 50px;
  box-shadow: none;
  background-color: var(--primary);
  color: black;
  padding: 10px;
  font-weight: 600;

  ${StyledIconBase} {
    color: black;
    height: 60%;
  }

  ${Row} {
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Header = styled.p`
  font-weight: 600;
  color: var(--secondary);
  margin-bottom: 14px;
  font-size: 12pt;
`;
